import { RootState } from '@iwProvider/configureStore';
import { ErrorCircleSVG } from '@svgComponents/errorCircleSVG';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Content } from '../Content';
import { PROCESSING_PAYMENT_MODAL_TRY_AGAIN } from '../ProcessingPaymentModal.actions';
import messages from './Failed.messages';
import styles from './Failed.module.css';

const mapStateToProps = ({
    processingPaymentModal
}: {
    processingPaymentModal: RootState['processingPaymentModal'];
}) => ({
    ...processingPaymentModal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToConfirm: () => dispatch({ type: PROCESSING_PAYMENT_MODAL_TRY_AGAIN })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const Failed = ({
    goToConfirm,
    senderLogo,
    receiverLogo
}: PropsFromRedux & {
    senderLogo: string;
    receiverLogo: string;
}) => (
    <Content
        title={<FormattedMessage {...messages.paymentError} />}
        icon={
            <span className={styles.processingDirectionError}>
                <ErrorCircleSVG
                    className={styles.ErrorCircleSVG}
                    data-testid="failed-payment-icon"
                />
            </span>
        }
        senderLogo={senderLogo}
        receiverLogo={receiverLogo}
        ctaOnClick={goToConfirm}
        ctaText={<FormattedMessage {...messages.close} />}
    />
);

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(Failed);
